module.exports = __webpack_public_path__ + "exo-latin-300italic.2f0f55679e620d222711.woff";


//////////////////
// WEBPACK FOOTER
// /srv/prod/FitRadioAdmin2/node_modules/typeface-exo/files/exo-latin-300italic.woff
// module id = ../../../../typeface-exo/files/exo-latin-300italic.woff
// module chunks = styles